import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import NavImg from "../../../assets/Dashboard/Navbar/logo.webp";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [activeItem, setActiveItem] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const pathMap = {
      "/exactness": "Exactness",
      "/api": "API",
      "/bulk": "Bulk",
      "/extension": "Extension",
      "/pricing": "Pricing",
      "/contact": "Contact",
    };
    setActiveItem(pathMap[location.pathname] || "Main");
  }, [location.pathname]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleNavigation = (path, label, isExternal = false) => {
    if (isExternal) {
      window.location.href = path;
      localStorage.setItem("hasVisitedApp", "true");
    } else {
      navigate(path);
    }
    setIsOpen(false);
  };

  const handleLogin = () => {
    localStorage.setItem("hasVisitedApp", "true");
    window.location.href = process.env.REACT_APP_BASE_URL + "/auth";
  };

  const handleDashboard = () => {
    localStorage.setItem("hasVisitedApp", "true");
    window.location.href = process.env.REACT_APP_BASE_URL;
  };

  const hasVisitedApp = localStorage.getItem("hasVisitedApp");

  return (
    <div>
      <nav className="bg-white border-gray-200 ">
        <div className="flex flex-wrap items-center md:pr-4 justify-between mx-auto min-[1090px]:px-10 min-[1090px]:py-5">
          <div className="flex items-center space-x-2 min-[1090px]:space-x-0 p-4 min-[1090px]:p-0 -ml-2">
            <button
              onClick={() => handleNavigation("/", "Main")}
              className="flex items-center justify-center min-[1090px]:mt-1"
            >
              <img
                src={NavImg}
                className="sm:w-full w-[230px] h-[38px] -ml-7 lg:-ml-4"
                alt="Navimage"
              />
            </button>
            <button
              type="button"
              onClick={toggleMenu}
              className="absolute right-0 transform -translate-x-1/2 inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-blue-800 rounded-lg min-[1090px]:hidden hover:text-blue-600 focus:outline-none"
              aria-controls="navbar-cta"
              aria-expanded={isOpen}
            >
              {isOpen ? (
                <svg
                  className="w-10 h-10"
                  aria-hidden="true"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              ) : (
                <svg
                  className="w-10 h-10"
                  aria-hidden="true"
                  fill="none"
                  viewBox="0 0 17 14"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M1 1h15M1 7h15M1 13h15"
                  />
                </svg>
              )}
            </button>
          </div>
          <div className="mr-16 min-[1090px]:mr-0">
            {hasVisitedApp === "true" ? (
              <div className="flex items-center justify-end space-x-4 min-[1090px]:space-x-3 min-[1090px]:-mb-1">
                <button
                  onClick={handleDashboard}
                  className="hidden md:flex md:items-center border text-white bg-background hover:bg-hover px-1 py-1.5 min-[1090px]:mb-1 rounded"
                >
                  <h1 className="font-semibold px-3">Go to App</h1>
                </button>
              </div>
            ) : (
              <div className="flex items-center justify-end space-x-4 min-[1090px]:space-x-3 min-[1090px]:-mb-1">
                <button
                  onClick={handleLogin}
                  className="hidden md:flex md:items-center border hover:text-hover px-1 py-1.5 min-[1090px]:mb-1 rounded"
                >
                  <h1 className="font-semibold px-3">Login</h1>
                </button>
                <button
                  onClick={handleDashboard}
                  className="hidden md:flex md:items-center text-white bg-background hover:bg-hover px-1 py-1.5 min-[1090px]:mb-1 rounded"
                >
                  <h1 className="font-semibold px-3">Start Trial</h1>
                </button>
              </div>
            )}
          </div>
          <div
            className={`${
              isOpen ? "block" : "hidden"
            } w-full min-[1090px]:flex min-[1090px]:justify-center min-[1090px]:items-center min-[1090px]:order-1 max-[1640px]:mr-0`}
            id="navbar-cta"
          >
            <hr className="my-1 min-[1090px]:my-0 bg-black" />
            <ul className="flex flex-col py-2 min-[1090px]:p-0 text-black bg-white rounded-lg min-[1090px]:flex-row min-[1090px]:space-x-11 min-[1090px]:-ml-24 min-[1090px]:-mt-[34px] min-[1090px]:pb-2">
              {[
                { label: "Exactness", path: "/exactness" },
                { label: "API", path: "/api" },
                { label: "Bulk", path: "/bulk" },
                { label: "Extension", path: "/extension" },
                { label: "Pricing", path: "/pricing" },
                { label: "Contact", path: "/contact" },
                {
                  label: "Login",
                  path: "https://exactmail.vercel.app/auth",
                  isExternal: true,
                },
              ].map(({ label, path, isExternal }, index) => (
                <li
                  key={index}
                  className={["Login"].includes(label) ? "md:hidden" : ""}
                >
                  <button
                    onClick={() => handleNavigation(path, label, isExternal)}
                    className={`flex items-center justify-between w-full px-3 py-2 min-[1090px]:p-0 transition duration-300 ease-in-out ${
                      activeItem === label ? "text-navbar" : "hover:text-navbar"
                    }`}
                    style={{
                      fontFamily: "sans-serif",
                      fontSize: "17px",
                      fontWeight: "600",
                    }}
                    aria-current="page"
                  >
                    <span>{label}</span>
                  </button>
                  <hr className="mt-1 min-[1090px]:my-0 bg-black min-[1090px]:hidden" />
                </li>
              ))}
            </ul>
          </div>
          <button
            onClick={() => {
              localStorage.setItem("hasVisitedApp", "true");
              window.location.href = process.env.REACT_APP_BASE_URL;
              setIsOpen(false);
            }}
            type="submit"
            className={`${
              isOpen ? "block" : "hidden"
            } w-full md:hidden bg-[#006EA5] font-bold text-white sm:p-4 px-3 py-3 rounded-md mx-3`}
          >
            {hasVisitedApp === "true" ? "Go to App" : "Start Trial"}
          </button>
        </div>
        {!isOpen && (
          <hr className="min-[1090px]:my-0 bg-black min-[1090px]:hidden" />
        )}
        <hr className="my-1 min-[1090px]:my-0 bg-black hidden min-[1090px]:block" />
      </nav>
    </div>
  );
}

export default Navbar;
